<bnd-button
  shape="square"
  mode="ghost"
  size="sm"
>
  @if (svgIcon(); as icon) {
    <mat-icon
      [svgIcon]="icon"
      [style.width.px]="size()"
      [style.height.px]="size()"
    />
  }
  @if (primeIcon(); as icon) {
    <i
      class="pi"
      [ngClass]="icon"
    ></i>
  }
</bnd-button>
<ng-content></ng-content>
